import { render, staticRenderFns } from "./ShelfContent.vue?vue&type=template&id=165461b6&scoped=true&"
import script from "./ShelfContent.vue?vue&type=script&lang=js&"
export * from "./ShelfContent.vue?vue&type=script&lang=js&"
import style0 from "./ShelfContent.vue?vue&type=style&index=0&id=165461b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165461b6",
  null
  
)

export default component.exports